import { render, staticRenderFns } from "./IncomeType.vue?vue&type=template&id=2219901e"
import script from "./IncomeType.vue?vue&type=script&lang=js"
export * from "./IncomeType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports